import { Result } from "appworks/model/gameplay/records/results/result";
import { Point } from "appworks/utils/geom/point";

export interface TGRInstantWin {
    cashWon: number;
    showingAmount: number;
    n: number;
    gridPosition: Point;
}

export class TGRInstantWinResult extends Result {
    public resultType: string = "TGRInstantWinResult";
    public instantWins: TGRInstantWin[] = [];
    public collectSymbolPosition: Point;
}
